import React, { useCallback, useEffect, useRef, useState } from 'react';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';

export default function ScrollRail({ children, className = '', label = 'Items' }) {
  const railRef = useRef(null);
  const [state, setState] = useState({ back: false, forward: false });
  const update = useCallback(() => {
    const rail = railRef.current;
    if (!rail) return;
    setState({ back: rail.scrollLeft > 4, forward: rail.scrollLeft + rail.clientWidth < rail.scrollWidth - 4 });
  }, []);
  useEffect(() => {
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, [children, update]);
  const move = (direction) => {
    const rail = railRef.current;
    if (!rail) return;
    rail.scrollBy({ left: direction * Math.max(240, rail.clientWidth * .78), behavior: 'smooth' });
  };
  return <div className={`set-scroll-rail-shell ${className}`}><button type="button" className="set-rail-arrow set-is-previous" onClick={() => move(-1)} disabled={!state.back} aria-label={`Previous ${label}`}><BsChevronLeft /></button><div className="set-scroll-rail" ref={railRef} onScroll={update} aria-label={label}>{React.Children.map(children, (child, index) => <div className="set-scroll-rail-item" key={child?.key || index}>{child}</div>)}</div><button type="button" className="set-rail-arrow set-is-next" onClick={() => move(1)} disabled={!state.forward} aria-label={`Next ${label}`}><BsChevronRight /></button></div>;
}
